import React from 'react';
import styled from 'styled-components';
import Loader from './loader';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const LoadingOverlay: React.FC = () => (
  <Overlay>
    <Loader />
  </Overlay>
);

export default LoadingOverlay;